export default {
  namespaced: true,
  state: () => ({
      
  })
};
